import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import "./Cart.css";

const Cart = () => {
  const {
    cart,
    updateQty,
    removeFromCart,
    total,
    clearCart,
  } = useContext(CartContext);

  return (
    <div className="cart-container">

      <h2>Your Cart</h2>

      {cart.length === 0 && (
        <p className="cart-empty">Cart is empty</p>
      )}

      {cart.length > 0 && (
        <button onClick={clearCart} className="remove-all-btn">
          Clear Cart
        </button>
      )}

      {cart.map((item) => (
        <div key={item.id} className="cart-item">

          <img
            src={item.image || item.images?.[0]}
            alt={item.name}
          />

          <div className="cart-info">

            <h4>{item.name}</h4>
            <p>£{item.price}</p>

            {/* QTY CONTROLS (FIXED) */}
            <div className="qty-controls">

              <button
                onClick={() =>
                  updateQty(item.id, item.qty - 1)
                }
              >
                -
              </button>

              <span>{item.qty}</span>

              <button
                onClick={() =>
                  updateQty(item.id, item.qty + 1)
                }
              >
                +
              </button>

            </div>

            <button
              className="remove-btn"
              onClick={() => removeFromCart(item.id)}
            >
              Remove
            </button>

          </div>
        </div>
      ))}

      {/* TOTAL (LIVE UPDATING) */}
      <h3 className="cart-total">
        Total: £{total.toFixed(2)}
      </h3>

      <button
        className="checkout-btn"
        onClick={() => (window.location.href = "/checkout")}
      >
        Proceed to Checkout
      </button>

    </div>
  );
};

export default Cart;